var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"100vw","min-height":"100vh"},attrs:{"src":require("../../assets/hscs/志愿者风采/志愿者风采.jpg"),"alt":""}})])}]

export { render, staticRenderFns }